import { AuthError, AuthErrorCode } from '../errors';

export const getAuthErrorMessage = (err: AuthError): string => {
  switch (err.code) {
    case AuthErrorCode.UsernameExistsException:
      return 'An account with the email already exists. Please attempt to sign-in.';
    case AuthErrorCode.UserNotConfirmedException:
      return `${err?.message} Please verify your email.`;
    case AuthErrorCode.UserNotFoundException:
      return 'Incorrect username or password';
    default:
      return err?.message;
  }
};
